<template>
  <div class="review" id="review">
    <div class="review-title">
      <div class="review-sun" data-scroll data-scroll-speed="-2"></div>
      <commonTitle :commonTitle="commonTitle"/>
      <div class="review-btn-wr slidetop" data-scroll data-scroll-call="animateMove">
         <div class="review-btn">
          <span ref="reviewbtn" :class="{active : activeIndex == index}" v-for="(itemBtn, index) in reviewData" :key="index" @click="changetab(index)">
            <b v-if="index <= 1">RTE {{itemBtn.round}}</b>
            <b v-else>RTC {{itemBtn.round}}</b>
          </span>
        </div>
      </div>
    </div>
    <div class="review-tab slidetop" data-scroll data-scroll-call="animateMove">
      <div class="review-item" :class="{activeShow: activeIndex == index1}" v-for="(item, index1) in reviewData" :key="index1+'1'">
        <swiper :options="swiperOption" ref="review">
          <swiper-slide class="review-slide" v-for="(itemImg) in item.data" :key="itemImg.id">
            <a :href="itemImg.link">
              <div class="review-hide">
                <figure><img :src="itemImg.cover" alt=""/></figure>
              </div>
              <p>{{itemImg.title}}</p>
            </a>
          </swiper-slide>
        </swiper>
        <div class="review-arrow prev"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.69 292.41"><g id="图层_2" data-name="图层 2"><g id="Capa_1" data-name="Capa 1"><polygon points="27.48 0 173.69 146.21 27.49 292.41 0 264.92 118.79 146.21 0.01 27.43 27.48 0"/></g></g></svg></div>
        <div class="review-arrow next"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 173.69 292.41"><g id="图层_2" data-name="图层 2"><g id="Capa_1" data-name="Capa 1"><polygon points="27.48 0 173.69 146.21 27.49 292.41 0 264.92 118.79 146.21 0.01 27.43 27.48 0"/></g></g></svg></div>
      </div>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/components/common/HomeTitle'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
export default {
  data () {
    return {
      activeIndex: 0,
      commonTitle: {
        title: '往届回顾',
        sen: 'review'
      },
      reviewData: [],
      swiperOption: {
        speed: 1000,
        loop: true,
        spaceBetween: 42,
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        navigation: {
          nextEl: '.review-arrow.next',
          prevEl: '.review-arrow.prev'
        },
        parallax: true,
        slidesPerView: 3,
        slidesPerGroup: 1,
        breakpoints: {
          640: {
            slidesPerView: 1,
            slidesPerGroup: 1
            // freeMode: true
          }
        }
      }
    }
  },
  props: {
    scroll: Object
  },
  methods: {
    async getReview () {
      const { data: res } = await this.$http.get('/historys')
      if (res.code === 1) {
        this.reviewData = res.data
        setTimeout(() => {
          console.log(1)
          this.scroll.update()
        }, 400)
      }
    },
    changetab (index) {
      this.activeIndex = index
      // eslint-disable-next-line array-callback-return
      this.$refs.review.map(item => {
        item.swiper.slideToLoop(0, 0, false)
      })
    }
  },
  components: {
    commonTitle,
    swiper,
    swiperSlide
  },
  mounted () {
    this.getReview()
  }
}
</script>

<style lang="less" scoped>
  @import url("@/assets/css/home/index.less");
</style>
